export default __webpack_public_path__ + "static/media/4.37284ad1.png";